import { range } from 'ramda';

export const getStartPage = (currentPageNumber: number, totalPages: number, paginationWidth: number): number =>
  Math.max(
    /** Нижняя граница - не может быть меньше 1 **/
    1,
    Math.min(
      /** Навигация до середины отрезка, исключая границы **/
      totalPages - paginationWidth + 2,
      /** Навигация после середины отрезка, исключая левую границу **/
      currentPageNumber - Math.floor(paginationWidth / 2) + 1,
    ),
  );

export const getEndPage = (
  startPage: number,
  currentPageNumber: number,
  totalPages: number,
  paginationWidth: number,
): number => {
  const endPage = Math.min(
    /** Верхняя граница, не может быть больше общего числа страниц **/
    totalPages,
    Math.max(
      /** Навигация до середины отрезка, исключая границы **/
      startPage + paginationWidth - 2,
      /** Навигация после середины отрезка, исключая правую границу **/
      currentPageNumber + Math.floor(paginationWidth / 2) - 1,
    ),
  );

  /** Навигация в середине отрезка **/
  return startPage >= 2 && endPage < totalPages ? startPage + paginationWidth - 3 : endPage;
};

export const getPageList = (currentPageNumber: number, totalPages: number, paginationWidth: number) => {
  const startPage = getStartPage(currentPageNumber, totalPages, paginationWidth);
  const endPage = getEndPage(startPage, currentPageNumber, totalPages, paginationWidth);

  /** Интервал [a, b) **/
  const pagesList = range(startPage, endPage + 1);

  /** Всегда отображаем первую страницу **/
  if (startPage > 1) {
    pagesList.unshift(1);
  }

  /** Всегда отображаем последнюю страницу **/
  if (endPage < totalPages) {
    pagesList.push(totalPages);
  }

  return {
    startPage,
    endPage,
    pagesList,
  };
};
